import type { PlanDuration } from '@vy/types';
import { isNullOrUndefined, isNotNumber } from '@vy/utils';
import { entries } from 'lodash';
import type { PlanSettingsSelectItem } from '../CreatePlanPage/create-plan-page-components/PlanSettingsSelect';
import { mapPlanDurationToLabel } from './duration-labels-handlers';

export function getPlanDurationValues(selectedValue?: number): PlanSettingsSelectItem<PlanDuration>[] {
  const planDurations = mapPlanDurationToLabel();
  const planDurationsArray = entries(planDurations).map(([value, label]) => ({
    value: Number(value),
    label,
  }));

  if (isNullOrUndefined(selectedValue) || isNotNumber(selectedValue)) {
    return planDurationsArray;
  }

  const valueIsInMap = planDurations[selectedValue];

  if (isNullOrUndefined(valueIsInMap)) {
    planDurationsArray.unshift({
      value: selectedValue,
      label: `${selectedValue} months`,
    });
  }

  return planDurationsArray;
}
